import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import ConsentText from './consent-text'
import { useState, useEffect } from 'react'
import { getLegalLinks } from '../helpers/legal-links'

const PrivacyPolice = ({ partner, setAgreed: setAllAgreed }) => {
  const { t, i18n } = useTranslation()
  const { privacy: aivyPrivacyLink } = getLegalLinks(i18n.language)

  const { customPrivacyLink, customPrivacyLinkReference } = JSON.parse(
    partner.app_settings?.components || '{}'
  )

  const partnerName = customPrivacyLinkReference
    ? 'Aivy\u00A0GmbH'
    : partner.name.replace(/ /g, '\u00A0')

  // Erstelle ein Consent-Objekt basierend darauf, ob ein customPrivacyLink existiert.
  // Die Platzhalter {{link}} und {{partnerLink}} bleiben ohne Werte stehen
  // (skipOnVariables) und werden in ConsentText durch die Links ersetzt
  let privacyConsent

  if (customPrivacyLink) {
    // Wenn ein benutzerdefinierter Link existiert, erstelle einen Text mit beiden Links
    privacyConsent = {
      text: t('privacy_consent.text_with_partner'),
      link: {
        href: aivyPrivacyLink,
        label: 'Aivy'
      },
      partnerLink: {
        href: customPrivacyLink,
        label: partnerName
      }
    }
  } else {
    // Wenn kein benutzerdefinierter Link existiert, verwende den Standard-Text
    privacyConsent = {
      text: t('privacy_consent.text'),
      link: {
        href: aivyPrivacyLink,
        label: t('privacy_consent.link_label')
      }
    }
  }

  const [agreed, setAgreed] = useState(false)

  useEffect(() => {
    setAllAgreed(agreed)
  }, [agreed, setAllAgreed])

  return (
    <div>
      <ConsentText
        consent={privacyConsent}
        agreed={agreed}
        setAgreed={setAgreed}
      />
    </div>
  )
}

PrivacyPolice.propTypes = {
  partner: PropTypes.object.isRequired,
  setAgreed: PropTypes.func.isRequired
}

export default PrivacyPolice
